export type ContainerWidth = 'sm' | 'md' | 'lg' | 'xl' | 'xxl';

export const ACTION_TYPES = {
  SET_CONTAINER_WIDTH: 'LAYOUT/SET_CONTAINER_WIDTH',
};

export type State = {
  containerWidth: ContainerWidth;
};
